import "./Homepage.css";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { apiRequest } from "services/apiRequest";
import { requestType } from "services/requests";

import Navbar from "../Navbar/Navbar";
import MessageOverview from "./MessageOverview/MessageOverview";
import PupilRequest from "./PupilRequest/PupilRequest";
import DefaultAvatar from "assets/images/kids-1 1.png";
import MoodLog from "./MoodLog/MoodLog";
import Loader from "utilities/reusableComponent/Loader/Loader";
import useEffectHook from "utilities/hook/useEffectHook";

function Homepage() {
  // get data user login from global state
  const { userInfo } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);
  const [teacherRequest, setTeacherRequest] = useState([]);
  const [conversationsData, setConversationsData] = useState([]);
  const [moodLogsData, setMoodLogsData] = useState([]);
  const [refreshTeacherRequest, setRefreshTeacherRequest] = useState(0);
  const [refreshMoodLogs, setRefreshMoodLogs] = useState(0);

  // Get data teacher request
  const getTeacherRequest = async () => {
    const response = await apiRequest({
      requestType: requestType.getTeacherRequests,
      payload: {
        data: {
          user_uid: userInfo?.uid,
          status: 1
        }
      },
    });
    if (response?.data?.status === 0) {
      const originalTeacherRequest = await(response.data.data);
      const teacherRequeses = originalTeacherRequest.map(function(item) {
        return {
          'uid' : item.uid,
          'name' : `${item.child_details.first_name} ${item.child_details.last_name}`,
          'avatar' : item.child_details.avatar_uid !== null ? item?.child_details?.child_avatar_details?.image_url : DefaultAvatar,
          'request_message': "Request to pair with you.",
          'datetime': item.tstamp_create,
        }
      })
      setTeacherRequest(teacherRequeses);
    }
  };

  const getTeacherDataHome = async () => {
    setLoading(true);
    const payload = {
      "user_uid": userInfo?.uid
    };
    const request = await apiRequest({
        requestType: requestType.getTeacherHomepage,
        payload: {
            data: payload
        },
    })
    const response = await request.data;
    if (response?.status === 0) {
      setConversationsData(response.data.conversations);
      setMoodLogsData(response.data.mood_logs);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }

  useEffectHook(() => {
      // get teacher request
      getTeacherRequest();
    }, [refreshTeacherRequest], 0
  );

  useEffectHook(() => {
      // get teacher home data
      getTeacherDataHome();
    }, [refreshMoodLogs], 0
  );

  return (
    <div className="homepage">
      <Navbar></Navbar>
      <MessageOverview 
        data={conversationsData}
      />
      <PupilRequest 
        data={teacherRequest}
        refreshTeacherRequest={refreshTeacherRequest}
        setRefreshTeacherRequest={setRefreshTeacherRequest}
      />
      <MoodLog 
        data={moodLogsData}
        refreshMoodLogs={refreshMoodLogs}
        setRefreshMoodLogs={setRefreshMoodLogs}
      />
      {loading && <Loader />}
    </div>
  );
}

export default Homepage;
